import { render, staticRenderFns } from "./JobBoardApplications.vue?vue&type=template&id=32c9b530"
import script from "./JobBoardApplications.vue?vue&type=script&lang=ts"
export * from "./JobBoardApplications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c9b530')) {
      api.createRecord('32c9b530', component.options)
    } else {
      api.reload('32c9b530', component.options)
    }
    module.hot.accept("./JobBoardApplications.vue?vue&type=template&id=32c9b530", function () {
      api.rerender('32c9b530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jobboard/JobBoardApplications.vue"
export default component.exports